export default "/images/vendor/flag-icon-css/flags/4x3/ky.svg?820198475abf3ac224f3875b5d1c87b9";